module.exports = __webpack_public_path__ + "img/empty.c06801a4.svg";